export const IMAGE = {
  HOMEPAGE: {
    CARD: {
      1: `${process.env.PUBLIC_URL}/assets/image/homepage/card-1.png`,
      2: `${process.env.PUBLIC_URL}/assets/image/homepage/card-2.png`,
      3: `${process.env.PUBLIC_URL}/assets/image/homepage/card-3.png`,
      4: `${process.env.PUBLIC_URL}/assets/image/homepage/card-4.png`,
    },
    CHAIN: {
      1: `${process.env.PUBLIC_URL}/assets/image/homepage/chain-1.png`,
      2: `${process.env.PUBLIC_URL}/assets/image/homepage/chain-2.png`,
      3: `${process.env.PUBLIC_URL}/assets/image/homepage/chain-3.png`,
      4: `${process.env.PUBLIC_URL}/assets/image/homepage/chain-4.png`,
    },
    COMMUNITY_TOOLS: `${process.env.PUBLIC_URL}/assets/image/homepage/community-tool.png`,
    ROCKET: `${process.env.PUBLIC_URL}/assets/image/homepage/rocket.png`,
  },
};
